import api from '@pray/shared/utils/api';

export type DeleteEmailHealthReportParams = {
  orgId: string;
  reportId: string;
};

export async function deleteEmailHealthReport({
  orgId,
  reportId,
}: DeleteEmailHealthReportParams): Promise<void> {
  const url = `/web/studio/email-health/${orgId}/reports/${reportId}`;
  await api.executeDeleteRequest(url);
}
